import { PrimaryButton } from 'ui/button';
import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { InfoBadge } from 'ui/badge';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { useTemplateDiffContext } from '../../context/TemplateDiffContext';

import type { TemplateDiffContentType } from '../../types';

type ContentRestoreButtonProps = {
  onClick: () => void;
  contentId: TemplateDiffContentType['id'];
};

export const ContentRestoreButton = ({ contentId, onClick }: ContentRestoreButtonProps) => {
  const { currentContentIds } = useTemplateDiffContext();
  const showCurrentVersionLabel = !!currentContentIds?.includes(contentId);

  return (
    <FlexSpacer flexDirection="column" alignItems="flex-end" gap="actionGap">
      <Tooltip
        isEnabled={showCurrentVersionLabel}
        isUsedOnButton
        tooltipContent="This is already the current content version"
      >
        <PrimaryButton
          isDisabled={showCurrentVersionLabel}
          data-test="table-diff-restore-content-action-button"
          onClick={onClick}
        >
          Restore
        </PrimaryButton>
      </Tooltip>
      {showCurrentVersionLabel && (
        <InfoBadge data-test="template-diff-current-version-badge">Current Version</InfoBadge>
      )}
    </FlexSpacer>
  );
};
